import { useContext } from "react";
import { ReportContext } from "../context";
import { useGetReportSummaryQuery } from "../services/shared.api";
function useLevels() {
    var _a, _b;
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { data: reportSummary } = useGetReportSummaryQuery({
        ui_id: reportId,
        diff_report_id: diffId,
    });
    const scanReport = reportSummary === null || reportSummary === void 0 ? void 0 : reportSummary.checks_report.report.scans[selectedCheck];
    return {
        scanLevel: (_a = scanReport === null || scanReport === void 0 ? void 0 : scanReport.inhibitors.scan_level) !== null && _a !== void 0 ? _a : 0,
        isLevelCustomized: (_b = scanReport === null || scanReport === void 0 ? void 0 : scanReport.inhibitors.customized) !== null && _b !== void 0 ? _b : false,
    };
}
export default useLevels;
//# sourceMappingURL=useLevels.js.map